(() => {
  const container = document.getElementById('ProductGridContainer');
  if (!container) return;

  container.addEventListener('click', (e) => {
    const btn = e.target.closest('#LoadMoreBtn');
    if (!btn) return;

    const nextUrl = btn.getAttribute('data-next-url');
    const sectionId = btn.getAttribute('data-section-id');
    if (!nextUrl) return;

    const textEl = btn.querySelector('.load-more-text');
    const spinnerEl = btn.querySelector('.load-more-spinner');
    btn.disabled = true;
    textEl.style.visibility = 'hidden';
    spinnerEl.style.display = 'flex';

    const fetchUrl = nextUrl + (nextUrl.includes('?') ? '&' : '?') + 'section_id=' + sectionId;

    fetch(fetchUrl)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fetchedGrid = doc.getElementById('product-grid');
        const currentGrid = document.getElementById('product-grid');

        if (fetchedGrid && currentGrid) {
          const items = fetchedGrid.querySelectorAll(':scope > li');
          items.forEach((item) => currentGrid.appendChild(item));
        }

        const currentPag = container.querySelector('.pagination-wrapper');
        const fetchedPag = doc.querySelector('.pagination-wrapper');
        if (currentPag && fetchedPag) {
          currentPag.replaceWith(fetchedPag);
        }

        const fetchedBtn = doc.getElementById('LoadMoreBtn');
        if (fetchedBtn) {
          btn.setAttribute('data-next-url', fetchedBtn.getAttribute('data-next-url'));
          btn.setAttribute('data-remaining', fetchedBtn.getAttribute('data-remaining'));
          textEl.textContent = fetchedBtn.querySelector('.load-more-text').textContent;
          btn.disabled = false;
          textEl.style.visibility = 'visible';
          spinnerEl.style.display = 'none';
        } else {
          btn.parentElement.style.display = 'none';
        }

        const cleanUrl = nextUrl.split('section_id=')[0].replace(/[&?]$/, '');
        history.replaceState(null, '', cleanUrl);
      })
      .catch(() => {
        btn.disabled = false;
        textEl.style.visibility = 'visible';
        spinnerEl.style.display = 'none';
      });
  });
})();
